/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetCountriesVariablesDTO = Types.Exact<{
  filter?: Types.Maybe<Types.CountryFilterDTO>;
}>;


export type GetCountriesDTO = (
  { __typename?: 'Query' }
  & { countries: Array<(
    { __typename?: 'Country' }
    & Pick<Types.CountryDTO, 'id' | 'name'>
  )> }
);


export const GetCountriesDocumentDTO = gql`
    query getCountries($filter: CountryFilter) {
  countries(filter: $filter, sort: [{field: "name", order: ASC}]) {
    id
    name
  }
}
    `;

/**
 * __useGetCountries__
 *
 * To run a query within a React component, call `useGetCountries` and pass it any options that fit your needs.
 * When your component renders, `useGetCountries` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountries({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCountries(baseOptions?: Apollo.QueryHookOptions<GetCountriesDTO, GetCountriesVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesDTO, GetCountriesVariablesDTO>(GetCountriesDocumentDTO, options);
      }
export function useGetCountriesLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesDTO, GetCountriesVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesDTO, GetCountriesVariablesDTO>(GetCountriesDocumentDTO, options);
        }
export type GetCountriesHookResult = ReturnType<typeof useGetCountries>;
export type GetCountriesLazyQueryDTOHookResult = ReturnType<typeof useGetCountriesLazyQueryDTO>;
export type GetCountriesQueryResultDTO = Apollo.QueryResult<GetCountriesDTO, GetCountriesVariablesDTO>;